var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.000000, 7.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.65,0.00405 C41.07105,0.00405 30.9501,6.885 26.5761,17.23275 C24.54705,16.55235 22.40865,16.20405 20.25,16.20405 C9.08415,16.20405 0,25.2882 0,36.45405 C0,46.23075 6.97005,54.4158 16.2,56.29095 L16.2,47.8548 C11.4939,46.1781 8.1,41.7231 8.1,36.45405 C8.1,29.75535 13.5513,24.30405 20.25,24.30405 C22.5585,24.30405 24.83055,24.97635 26.8029,26.24805 C27.91665,26.96895 29.30175,27.0945 30.51675,26.6004 C31.7439,26.1063 32.643,25.0452 32.94675,23.7654 C35.0811,14.54355 43.18515,8.10405 52.65,8.10405 C63.81585,8.10405 72.9,17.1882 72.9,28.35405 C72.9,34.9434 69.68835,40.7511 64.8,44.4528 L64.8,53.9298 C74.36205,49.3695 81,39.63735 81,28.3581 C81,12.7251 68.27895,0.00405 52.65,0.00405 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.56335 49.7907 40.5 30.72735 21.43665 49.7907 27.16335 55.5174 36.45 46.23075 36.45 81.00405 44.55 81.00405 44.55 46.23075 53.83665 55.5174"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.211fa0272384336d09f1fa9f9b1a605e.svg";
export { ForwardRef as ReactComponent };